import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import UrlParse from 'url-parse';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import TagList from '~/components/molecules/Editorial/Global/TagList.vue';
export default {
  name: 'TagListBlock',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    TagList: TagList
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    tagList: function tagList() {
      var _this = this;

      if (!this.catalog.categories) {
        return null;
      }

      return this.payload.items.reduce(function (acc, item) {
        var cat = _this.catalog.categories.find(function (_ref2) {
          var hash = _ref2.hash;
          return hash === item.hash;
        });

        if (cat) {
          acc.push({
            title: cat.name,
            url: _this.buildCategoryUrl(_this.locale, cat.slug, cat.hash),
            tagColor: _this.payload.primary.tag_color,
            tagType: _this.payload.primary.tag_type,
            tagLight: _this.payload.primary.tag_light === 'Yes',
            tracking: {
              data: {
                event_category: item.event_category,
                event_action: item.event_action,
                event_label: item.event_label
              }
            }
          });
        }

        return acc;
      }, []);
    },
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    titleColor: function titleColor() {
      return this.payload.primary.title_color;
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    subtitleColor: function subtitleColor() {
      return this.payload.primary.subtitle_color;
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph;
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    button: function button() {
      var _ref;

      return {
        text: this.payload.primary.button_text,
        url: new UrlParse(((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.button_url) != null ? _ref.url : _ref : _ref : _ref) || '').pathname,
        tracking: {
          data: {
            event_category: this.payload.primary.event_category,
            event_action: this.payload.primary.event_action,
            event_label: this.payload.primary.event_label
          }
        }
      };
    }
  })
};